import {h, Component} from 'preact';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import Page from "../../../services/page-data-feed";

import SchedulesTimeFilter from "../utils/schedules-time-filter";
import * as M from "../desktop-templates/prematch-menu.jsx";
import AwrabetMenuTimeFilter from '../../awrabet/desktop-components/menu-time-filter.jsx';


export default class MenuTimeFilter extends AwrabetMenuTimeFilter {
	render() {
		return <div>
			<M.MenuTitle><Trans>Quick Filter</Trans></M.MenuTitle>
			<M.TimeFilterButtonContainer>
				{this.getButtons().map(tab => (
					<M.TimeFilterButton 
					  onClick={e => {this.setTimeFilter(tab.value)}} 
					  active={this.getCurrentFilter() == tab.value}>
						{tab.name}
					</M.TimeFilterButton>
				))}
			</M.TimeFilterButtonContainer>
		</div>
	}
}